/* HANBOLI COCO — JS asset. ارفعيه في Assets. يُستدعى في Custom Liquid 2 عبر:
   {{ 'hanboli.js' | asset_url | script_tag }} */
(function(){
  var R=document;

  var rev=R.querySelectorAll('.hanboli-lp .reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1});
    rev.forEach(function(el){io.observe(el);});
  }else{rev.forEach(function(el){el.classList.add('in');});}

  var sticky=R.querySelector('.sticky');
  var hideEls=R.querySelectorAll('#offers,.micro-trust');
  if(sticky&&hideEls.length&&'IntersectionObserver' in window){
    var vis=new Set();
    var so=new IntersectionObserver(function(es){
      es.forEach(function(e){e.isIntersecting?vis.add(e.target):vis.delete(e.target);});
      sticky.classList.toggle('is-hidden',vis.size>0);
    },{threshold:0});
    hideEls.forEach(function(el){so.observe(el);});
  }

  R.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('a[href="#offers"]'):null;
    if(!a)return;
    var t=R.getElementById('offers');
    if(!t)return;
    e.preventDefault();
    if(t.scrollIntoView)t.scrollIntoView({behavior:'smooth',block:'start'});
    else location.hash='#offers';
  });

  var gMain=R.querySelector('#gMain');
  var gWrap=R.querySelector('.gallery');
  var gThumbs=Array.prototype.slice.call(R.querySelectorAll('.gthumb'));
  if(gMain&&gThumbs.length){
    var gIdx=0,gTimer=null;
    var gDelay=parseInt(gWrap&&gWrap.getAttribute('data-autoplay')||'2000',10)||2000;
    gThumbs.forEach(function(t){var s=t.getAttribute('data-src');if(s){var im=new Image();im.src=s;}});
    function gReady(){gMain.classList.remove('is-swapping');}
    gMain.addEventListener('load',gReady);
    gMain.addEventListener('error',gReady);
    function gShow(i){
      gIdx=(i+gThumbs.length)%gThumbs.length;
      var src=gThumbs[gIdx].getAttribute('data-src');
      if(src&&gMain.getAttribute('src')!==src){gMain.classList.add('is-swapping');gMain.setAttribute('src',src);}
      gThumbs.forEach(function(x,k){x.classList.toggle('active',k===gIdx);});
    }
    function gStop(){if(gTimer){clearInterval(gTimer);gTimer=null;}}
    function gPlay(){gStop();if(gThumbs.length>1)gTimer=setInterval(function(){gShow(gIdx+1);},gDelay);}
    gThumbs.forEach(function(t,i){t.addEventListener('click',function(){gShow(i);gPlay();});});
    if(gWrap&&window.matchMedia&&window.matchMedia('(hover:hover)').matches){
      gWrap.addEventListener('pointerenter',gStop);
      gWrap.addEventListener('pointerleave',gPlay);
    }
    R.addEventListener('visibilitychange',function(){R.hidden?gStop():gPlay();});
    gPlay();
  }

  R.querySelectorAll('.ba').forEach(function(el){
    var pos=50;
    function set(p){p=Math.max(0,Math.min(100,p));pos=p;el.style.setProperty('--pos',p+'%');el.setAttribute('aria-valuenow',Math.round(p));}
    function fromX(x){var r=el.getBoundingClientRect();if(r.width)set((x-r.left)/r.width*100);}
    var drag=false;
    function pt(e){return e.touches&&e.touches.length?e.touches[0].clientX:e.clientX;}
    function down(e){drag=true;fromX(pt(e));if(e.pointerId!=null&&el.setPointerCapture){try{el.setPointerCapture(e.pointerId);}catch(_){}}}
    function move(e){if(drag)fromX(pt(e));}
    function up(){drag=false;}
    if(window.PointerEvent){el.addEventListener('pointerdown',down);el.addEventListener('pointermove',move);el.addEventListener('pointerup',up);el.addEventListener('pointercancel',up);}
    else{el.addEventListener('mousedown',down);window.addEventListener('mousemove',move);window.addEventListener('mouseup',up);el.addEventListener('touchstart',down,{passive:true});el.addEventListener('touchmove',move,{passive:true});el.addEventListener('touchend',up);}
    el.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){set(pos-4);e.preventDefault();}else if(e.key==='ArrowRight'){set(pos+4);e.preventDefault();}});
    set(50);
  });

  var ar=['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
  function toAr(n){return String(n).replace(/[0-9]/g,function(d){return ar[+d];});}
  function fromAr(s){return parseInt((s.match(/[٠-٩0-9]/g)||[]).map(function(c){var i=ar.indexOf(c);return i<0?c:i;}).join(''),10)||0;}
  R.querySelectorAll('.review .help').forEach(function(b){
    var base=fromAr(b.textContent);
    b.addEventListener('click',function(){var on=b.classList.toggle('on');b.textContent='👍 مفيد ('+toAr(base+(on?1:0))+')';});
  });
})();
